<template>
  <v-row>
    <v-row class="mx-2">
      <v-icon v-if="icon.length > 0">{{ icon }}</v-icon>
      <p v-else class="text-center subtitle-1">{{ nombre }}</p>
      <v-spacer />
      <v-btn
        :loading="loadingImagenAux"
        small
        class="red mr-4"
        v-if="imagenAuxSrc && !soloBoton"
        @click="imagenAuxSrc = ''"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-btn
        v-if="!soloBoton"
        :loading="loadingImagenAux"
        small
        class="secondary"
        @click="cambiarImagen('subir')"
      >
        <v-icon>mdi-reload</v-icon>
      </v-btn>
      <v-btn
        v-else
        x-large
        :loading="loadingImagenAux"
        small
        class="secondary"
        @click="cambiarImagen('subir')"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-file-input
        class="d-none"
        :ref="'subir'"
        color="deep-purple accent-4"
        counter
        label="File input"
        placeholder="Select your files"
        prepend-icon="mdi-paperclip"
        outlined
        v-model="imagenAux"
        @change="cambiarImagenFichero()"
        :show-size="1000"
      />
    </v-row>
    <v-img :src="imagenAuxSrc" :max-height="imgHeight" v-if="!soloBoton" />
  </v-row>
</template>

<script>
export default {
  props: {
    nombre: {
      required: false,
      default: "nombre",
    },
    icon: {
      required: false,
      default: "",
    },
    soloBoton: {
      required: false,
      default: false,
    },
    childStorage: {
      required: false,
      default: false,
    },
    imgHeight: {
      required: false,
      default: "150px",
    },
    propImg: {
      required: false,
      default: "",
    },
  },
  data() {
    return {
      imagenAux: null,
      loadingImagenAux: false,
      imagenAuxSrc: "",
    };
  },
  methods: {
    cambiarImagen(s) {
      this.imagenCambiando = s;
      this.$refs[s].$refs.input.click();
    },
    cambiarImagenFichero() {
      let _vm = this;
      _vm.loadingImagenAux = true;
      this.$store
        .dispatch("propio/subirImagen", {
          //tipo: this.imagenCambiando,
          imagen: this.imagenAux,
          child: this.childStorage,
        })
        .then((img) => {
          if (img) {
            this.imagenAuxSrc = img;
            this.$emit("imagen-subida", img);
          }
        })
        .finally(() => (_vm.loadingImagenAux = false));
    },
  },
  mounted() {
    this.imagenAuxSrc = this.propImg;
  },
};
</script>

<style>
</style>